// Maps field types to their React components
// Lets FieldAccordionItem / RepeaterField (and app layouts) render fields from config
import type { ComponentType } from 'react';
import type { FieldType, BaseFieldProps } from '../types/fields';
import {
  TextField,
  TextAreaField,
  SelectField,
  DateField,
  RadioField,
  FileField,
  ImageField,
  VideoField,
  MultiselectField,
  RepeaterField,
  MultiselectDropdownField,
} from '../components/fields';

// Registry of field type -> component
// Add new field types here as they're implemented
export const fieldRegistry: Partial<Record<FieldType, ComponentType<BaseFieldProps>>> = {
  text: TextField,
  email: TextField,
  url: TextField,
  textarea: TextAreaField,
  select: SelectField,
  date: DateField,
  radio: RadioField,
  file: FileField,
  image: ImageField,
  video: VideoField,
  multiselect: MultiselectField,
  repeater: RepeaterField,
  multiselectDropdown: MultiselectDropdownField,
};

// Get component for a field type, with fallback to text
export function getFieldComponent(type: FieldType): ComponentType<BaseFieldProps> {
  const component = fieldRegistry[type];
  if (!component) {
    console.warn(`No component registered for field type: ${type}. Falling back to text.`);
    return TextField;
  }
  return component;
}
